import React from 'react';
import { motion } from 'framer-motion';
export function Stats() {
  return <section className="py-24 bg-[#D4DDE8]" data-id="element-229">
      <div className="container mx-auto px-6" data-id="element-230">
        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-231">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="max-w-md" data-id="element-232">
            <p className="text-lg leading-relaxed text-primary-dark/80" data-id="element-233">
              AccuTemp is Nuneaton's leading commercial HVAC specialist. With
              over 16 years of experience and Daikin D1+ Premier Partner status,
              we deliver installation, maintenance, and compliance services that
              last.
            </p>
          </motion.div>

          <div className="grid grid-cols-2 gap-12" data-id="element-234">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.1
          }} data-id="element-235">
              <div className="text-5xl md:text-6xl font-light mb-2" data-id="element-236">16+</div>
              <div className="text-sm text-primary-dark/60 uppercase tracking-wider" data-id="element-237">
                Years experience
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} data-id="element-238">
              <div className="text-5xl md:text-6xl font-light mb-2" data-id="element-239">0</div>
              <div className="text-sm text-primary-dark/60 uppercase tracking-wider" data-id="element-240">
                Manufacturer callbacks
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.3
          }} data-id="element-241">
              <div className="text-5xl md:text-6xl font-light mb-2" data-id="element-242">1,000+</div>
              <div className="text-sm text-primary-dark/60 uppercase tracking-wider" data-id="element-243">
                Commercial projects
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.4
          }} data-id="element-244">
              <div className="text-5xl md:text-6xl font-light mb-2" data-id="element-245">4-6wk</div>
              <div className="text-sm text-primary-dark/60 uppercase tracking-wider" data-id="element-246">
                Faster than rivals
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}